import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import UserAccountApi from '../../../api/services/UserAccount/UserAccount.service';

const initialState = {
  userDetails: {},
  isAccount: false,
  loading: false,
  error: {},
};

type Data = {
  id: string | undefined;
};

export const userAccountCall = createAsyncThunk(
  'userAccountCall',
  async (payload: Data, { rejectWithValue }) => {
    try {
      const res = await UserAccountApi.UserAccount(payload);
      if (res?.data?.error) {
        return rejectWithValue(res.data);
      }
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);

const userAccount = createSlice({
  name: 'userAccount',
  initialState,
  reducers: {
    account: (state, action) => {
      state.isAccount = action.payload;
    },
    clearAccountData: state => {
      state.userDetails = {};
    },
  },
  extraReducers: builder => {
    builder
      .addCase(userAccountCall.pending, () => {})
      .addCase(userAccountCall.fulfilled, (state: any, action) => {
        state.userDetails = action.payload;
        state.loading = false;
      })
      .addCase(userAccountCall.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { account, clearAccountData } = userAccount.actions;

export default userAccount.reducer;
